import {
  ReadOnly,
  Select,
  useEntityPermission,
  useLocalization,
} from '@ui-framework/index';
import { observer } from 'mobx-react';
import React, { forwardRef } from 'react';
import { useFormContext } from 'react-hook-form';

const SelectStatic = forwardRef(
  ({ overwriteProps = {}, customConfig, ...props }, ref) => {
    const { options } = customConfig;
    const { getValues } = useFormContext();
    const { formatMessage } = useLocalization();
    const { isHidden, isReadOnly } = useEntityPermission();

    const currentvalue = getValues(props?.field?.name);
    const hasStatus = options.some(obj => 'status' in obj);

    let newOptions = options;
    if (hasStatus) {
      newOptions = options
        .filter(item => {
          return item.status === true || item.value === currentvalue;
        })
        .map(item => {
          if (item.status === true) {
            return item;
          }
          return {
            ...item,
            label: `${item.label} (${formatMessage({ id: 'IN_ACTIVE', defaultMessage: 'In-Active' })})`,
          };
        });
    }

    if (isReadOnly(props?.permission, currentvalue)) {
      return (
        <ReadOnly name={props?.field?.name}>
          {options.find(i => i.value === currentvalue)?.label}
        </ReadOnly>
      );
    }

    if (isHidden(props?.permission)) {
      return (
        <input type="hidden" name={props?.field?.name} value={currentvalue} />
      );
    }

    return (
      <Select
        ref={ref}
        options={newOptions}
        {...props}
        overwriteProps={overwriteProps}
      />
    );
  },
);

export default observer(SelectStatic);
